import type { ReactElement } from 'react';
import React, {useContext} from 'react';
import {SkeletonBrick} from "@Components/skeleton-brick";
import {ModalDetails} from "@Components/modal/modal-context";
import type {StylesInputPanelLoadingProps} from './styles-input-panel-loading.types';
import styles from './styles-input-panel-loading.module.scss';

export function StylesInputPanelLoading(
    {

    }: StylesInputPanelLoadingProps ): ReactElement {

    const modalDetailsContext = useContext(ModalDetails);
    const isInModal = modalDetailsContext !== null;

    return (
        <div className={`${isInModal ? 'spacing-p-5': 'spacing-p-10'} flex-v-row`}>
            <SkeletonBrick className="radius-4 _full-width spacing-m-b-3" />
            <SkeletonBrick className={`radius-4 ${styles.skeletonTile} spacing-m-b-3`} />
            <SkeletonBrick className={`radius-4 _full-width ${isInModal ? 'spacing-m-b-5': 'spacing-m-b-10'}`} />
            <SkeletonBrick className="`radius-4 _full-width spacing-m-b-3" />
            <SkeletonBrick className={`radius-4 ${styles.skeletonTile} spacing-m-b-3`} />
            <SkeletonBrick className="radius-4 _full-width" />
        </div>
    );
}